import { BaseAPI } from "@/api/baseAPI";
import type { BranchArea } from "@/types";
class BranchAreaAPI extends BaseAPI<BranchArea> {
  constructor() {
    super("area");
  }
}

export default new BranchAreaAPI();
